module.exports = __webpack_public_path__ + "assets/crying_face.e682d19e530464fe9c6cd8d1e945f586.png";